var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#ADADAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5821 10.2463C24.3521 9.3621 23.6744 8.66574 22.8139 8.42942C21.2542 8 15 8 15 8C15 8 8.74586 8 7.18613 8.42942C6.32565 8.66578 5.64794 9.3621 5.41792 10.2463C5 11.8489 5 15.1927 5 15.1927C5 15.1927 5 18.5365 5.41792 20.1392C5.64794 21.0233 6.32565 21.6907 7.18613 21.927C8.74586 22.3564 15 22.3564 15 22.3564C15 22.3564 21.2541 22.3564 22.8139 21.927C23.6744 21.6907 24.3521 21.0233 24.5821 20.1392C25 18.5365 25 15.1927 25 15.1927C25 15.1927 25 11.8489 24.5821 10.2463ZM12.9545 18.2286V12.1568L18.1818 15.1928L12.9545 18.2286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b172653aec6b10a83192bef7543feda6.svg";
export { ForwardRef as ReactComponent };